import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    denominacion: Yup.string(),
    capacidad: Yup.string().matches('^[0-9]+$', {message: "La capacidad debe ser un número", excludeEmptyString: true}),
})

export default validationSchema